/**
 * Contains environment specific configuration items, which is exported and passed to components
 */

const EnvConfig = {
  local: {
    auth: {
      clientId: "32b4faea-e784-44e9-bb6e-75e6d33e9b3f",
      tenantId: "4667418b-7015-4ceb-b207-2193896769a8",
      apiScope: "api://7725c127-27ad-47c2-be78-09ef954a8e0c/Discover.APIAuth"
    },
    gnavAuth: {
        clientId: "65f8a822-e2c2-480c-a1b4-dfa3ce1d5e25",
        tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
        redirectUrl: "http://localhost:3000",
        apiScope: "d35b01f6-1d4a-4e9d-af03-7ae387837dd2/AEM.AAOC.Read",
        gnavHeaderEndpoint: "https://discovercontent-dev.ey.net/bin/eyd/aaoc/service/xf/header",
        domainHint: "5b973f99-77df-4beb-b27d-aa0c70b8482c"
    },
    peopleProfile: {
      baseUrl: "https://eycloudappdev-my.sharepoint.com/PersonImmersive.aspx"
    },
    RecentlyView: {
      sourceId: "15a4b0c7-4052-433a-a603-ad3649ce00ac"
    },
    Popular: {
      sourceId: "15a4b0c7-4052-433a-a603-ad3649ce00ac",
    },
    Topic: {
      sourceId: "5c4a8fa5-531f-401f-ab9b-783ca91d3f6e",
    },
    Results: {
      sourceId: "15a4b0c7-4052-433a-a603-ad3649ce00ac",
    },
    RelatedAssets: {
      sourceId: "15a4b0c7-4052-433a-a603-ad3649ce00ac"
    },
    cmsUrl: "https://eycloudappdev.sharepoint.com/sites/discoverdata/Lists/DiscoverDataTopics/DispForm.aspx",
    DefaultSharepointURL:"https://sites.ey.com",
    accessDashboard:{
      AccessRequestURL:"https://sites.ey.com/sites/discoverdata-dev/Lists/DiscoverDataAsset/DispForm.aspx?ID=",
    },
    dataProviderHoverImageURL: "https://discovercdn-dev.azureedge.net/discoverdata",
    adobeSource: "//assets.adobedtm.com/68ca638811bd/dff7c0a49bbc/launch-8748f06babff-development.min.js"
  },
  development: {
    auth: {
      clientId: "65f8a822-e2c2-480c-a1b4-dfa3ce1d5e25",
      tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
      apiScope: "api://2a6227a3-dabb-4ea8-b32c-4ba212fde738/Discover.APIAuth"
    },
    gnavAuth: {
        clientId: "65f8a822-e2c2-480c-a1b4-dfa3ce1d5e25",
        tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
        redirectUrl: "https://data-dev.discover.ey.com",
        apiScope: "d35b01f6-1d4a-4e9d-af03-7ae387837dd2/AEM.AAOC.Read",
        gnavHeaderEndpoint: "https://discovercontent-dev.ey.net/bin/eyd/aaoc/service/xf/header",
        domainHint: "5b973f99-77df-4beb-b27d-aa0c70b8482c"
    },
    peopleProfile: {
      baseUrl: "https://people.ey.com/PersonImmersive.aspx"
    },
    RecentlyView: {
      sourceId: "68db0562-97ea-42a2-9a40-05b65f719999"
    },
    Popular: {
      sourceId: "2bebfd46-baf5-4c8b-9bca-06e4c5688134"
    },
    Topic: {
      sourceId: "ecfbea04-3afc-48e2-912f-03af5d524c90"
    },
    Results: {
      sourceId: "2bebfd46-baf5-4c8b-9bca-06e4c5688134"
    },
    RelatedAssets: {
      sourceId: "2bebfd46-baf5-4c8b-9bca-06e4c5688134"
    },
    cmsUrl: "https://sites.ey.com/sites/discoverdata-dev/Lists/DiscoverDataTopics/DispForm.aspx",
    DefaultSharepointURL:"https://sites.ey.com",
    accessDashboard:{
      AccessRequestURL:"https://sites.ey.com/sites/discoverdata-dev/Lists/DiscoverDataAsset/DispForm.aspx?ID=",
    },
    dataProviderHoverImageURL: "https://discovercdn-dev.azureedge.net/discoverdata",
    adobeSource: "//assets.adobedtm.com/68ca638811bd/dff7c0a49bbc/launch-8748f06babff-development.min.js"
  },
  qa: {
    auth: {
      clientId: "de90b84e-9dc0-4bf9-9d27-0b28be7a4cc5",
      tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
      apiScope: "api://c7da513f-5f82-479c-ad74-b2b506ef5e18/Discover.APIAuth"
    },
    gnavAuth: {
        clientId: "de90b84e-9dc0-4bf9-9d27-0b28be7a4cc5",
        tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
        redirectUrl: "https://data-qa.discover.ey.com",
        apiScope: "cdecdaec-87f1-40b1-9c14-38fa6e40bc46/AEM.AAOC.Read",
        gnavHeaderEndpoint: "https://discovercontent-qa.ey.net/bin/eyd/aaoc/service/xf/header",
        domainHint: "5b973f99-77df-4beb-b27d-aa0c70b8482c"
    },
    peopleProfile: {
      baseUrl: "https://people.ey.com/PersonImmersive.aspx",
    },
    RecentlyView: {
      sourceId: "81742d7a-d7e3-4176-87f1-e687b2587ad6"
    },
    Popular: {
      sourceId: "0e1350d8-d218-4f35-8365-597e9a55ce4c",
    },
    Topic: {
      sourceId: "d8704eb4-d8f7-448e-b576-cf215972accb",
    },
    Results: {
      sourceId: "0e1350d8-d218-4f35-8365-597e9a55ce4c",
    },
    RelatedAssets: {
      sourceId: "0e1350d8-d218-4f35-8365-597e9a55ce4c",
    },
    cmsUrl: "https://sites.ey.com/sites/discoverdata-qa/Lists/DiscoverDataTopics/DispForm.aspx",
    DefaultSharepointURL:"https://sites.ey.com",
    accessDashboard:{
      AccessRequestURL:"https://sites.ey.com/sites/discoverdata-qa/Lists/DiscoverDataAsset/DispForm.aspx?ID=",
    },
    dataProviderHoverImageURL: "https://discovercdn-qa.azureedge.net/discoverdata",
    adobeSource: "//assets.adobedtm.com/68ca638811bd/dff7c0a49bbc/launch-7f71556e5010-staging.min.js"    
  },
  uat: {
    auth: {
      clientId: "4ae74f74-9f85-42e1-ab3a-5a663af47ace",
      tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
      apiScope: "api://910b9235-465d-485e-baf6-1da7ffabc410/Discover.APIAuth"
    },
    gnavAuth: {
        clientId: "4ae74f74-9f85-42e1-ab3a-5a663af47ace",
        tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
        redirectUrl: "https://data-uat.discover.ey.com/",
        apiScope: "cdecdaec-87f1-40b1-9c14-38fa6e40bc46/AEM.AAOC.Read",
        gnavHeaderEndpoint: "https://discovercontent-qa.ey.net/bin/eyd/aaoc/service/xf/header",
        domainHint: "5b973f99-77df-4beb-b27d-aa0c70b8482c"
    },
    peopleProfile: {
      baseUrl: "https://people.ey.com/PersonImmersive.aspx"
    },
    RecentlyView: {
      sourceId: "fc13dc7f-f423-4754-8b0c-dd552175cb8b"
    },
    Popular: {
      sourceId: "c9ae0f64-07bf-467c-a37c-0424a4aa6cb3"
    },
    Topic: {
      sourceId: "4edcf490-f4fd-45dd-8475-82011cde4db7"
    },
    Results: {
      sourceId: "c9ae0f64-07bf-467c-a37c-0424a4aa6cb3"
    },
    RelatedAssets: {
      sourceId: "c9ae0f64-07bf-467c-a37c-0424a4aa6cb3"
    },
    cmsUrl: "https://sites.ey.com/sites/discoverdata-de-uat/Lists/DiscoverDataTopics/DispForm.aspx",
    DefaultSharepointURL:"https://sites.ey.com",
    accessDashboard:{
      AccessRequestURL:"https://sites.ey.com/sites/discoverdata-de-uat/Lists/DiscoverDataAsset/DispForm.aspx?ID=",
    },
    dataProviderHoverImageURL: "https://discovercdn-qa.azureedge.net/discoverdata",
    adobeSource: "//assets.adobedtm.com/68ca638811bd/dff7c0a49bbc/launch-7f71556e5010-staging.min.js"    
  },
  prod: {
    auth: {
      clientId: "aa563026-f0b8-4034-95fb-2923627bfdf2",
      tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
      apiScope: "api://26e36150-59cc-4f1c-8afe-0983163e2f51/Discover.APIAuth"
    },
    gnavAuth: {
        clientId: "aa563026-f0b8-4034-95fb-2923627bfdf2",
        tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c",
        redirectUrl: "https://data.discover.ey.com",
        apiScope: "d8189e08-8225-4287-986c-3ce29b2232b9/AEM.AAOC.Read",
        gnavHeaderEndpoint: "https://discovercontent.ey.net/bin/eyd/aaoc/service/xf/header",
        domainHint: "5b973f99-77df-4beb-b27d-aa0c70b8482c"
    },
    peopleProfile: {
      baseUrl: "https://people.ey.com/PersonImmersive.aspx"
    },
    RecentlyView: {
      sourceId: "ba915df7-f081-415c-994d-1063c12de2e2"
    },
    Popular: {
      sourceId: "9273c74c-a036-4920-9b8f-3de99e95452c"
    },
    Topic: {
      sourceId: "f586f6b1-4466-4981-b03d-8154b648020d"
    },
    Results: {
      sourceId: "9273c74c-a036-4920-9b8f-3de99e95452c"
    },
    RelatedAssets: {
      sourceId: "9273c74c-a036-4920-9b8f-3de99e95452c"
    },
    cmsUrl: "https://sites.ey.com/sites/discoverdata/Lists/DiscoverDataTopics/DispForm.aspx",
    DefaultSharepointURL:"https://sites.ey.com",
    accessDashboard:{
      AccessRequestURL:"https://sites.ey.com/sites/discoverdata/Lists/DiscoverDataAsset/DispForm.aspx?ID=",
    },
    dataProviderHoverImageURL: "https://discovercdn.azureedge.net/discoverdata",
    adobeSource: "//assets.adobedtm.com/68ca638811bd/dff7c0a49bbc/launch-a35edf7a4e4e.min.js"    
  }
};

export default EnvConfig[process.env.REACT_APP_ENVIRONMENT_NAME];